import React from 'react';
import WarningComponent from './WarningComponent';
import { EVENT_WARNING_TYPES } from '../../constants/EventWarningTypes';

/**
 * @typedef {object} EventCardContentProps
 * @property {number} [eventId]
 * @property {string} [atlName]
 * @property {string} [orgUnitNames]
 * @property {string} [deliveryMethod]
 * @property {Array<*>} [warningTypes]
 * @property {boolean} [hideBidWarnings]
 */

/**
 * @param {EventCardContentProps} props
 */
const EventCardContent = props => {
  const {
    atlName,
    orgUnitNames,
    eventId,
    deliveryMethod,
    hideBidWarnings,
    warningTypes = []
  } = props;

  const filteredWarningTypes = hideBidWarnings
    ? warningTypes.filter(x => x !== EVENT_WARNING_TYPES.ATM_BID_SUBMISSION)
    : warningTypes;

  return (
    <div data-testid={`event-content-${eventId}`} className='event-content'>
      <div className='content-wrapper'>
        <div className='org-names'>{orgUnitNames}</div>
        <div className='atl-name'>ATL: {atlName || 'TBD'}</div>
        {deliveryMethod && <div className='delivery-method-name'>{deliveryMethod}</div>}
      </div>
      {filteredWarningTypes.length !== 0 && (
        <div className='warning-icons'>
          {filteredWarningTypes.map((warningType, index) => (
            <WarningComponent
              key={`warning-icon-${index}-${warningType}`}
              warningType={warningType}
              eventId={eventId}
              renderIconAsTitle={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default EventCardContent;
